import { useEffect } from 'react';

import { useUserProfile } from '@/states/user-profile';
import { devlog } from '@/libs/dev-logs';

export function LogoutPage() {
  const { profile, clear } = useUserProfile();

  useEffect(() => {
    // remove the state
    if (profile?.email) {
      devlog('clearing user profile');
      clear();
    }
  });

  return <div className="flex-full-center">Closing session...</div>;
}
